<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path class="thumb-up-a" d="M-972-6905a10.011,10.011,0,0,1-10-10,10.012,10.012,0,0,1,10-10,10.012,10.012,0,0,1,10,10A10.011,10.011,0,0,1-972-6905Zm-5.563-11.613v6.121h1.112a.557.557,0,0,0,.556-.556v-5.009a.557.557,0,0,0-.556-.556Zm6.675-3.9-3.566,3.568a1.11,1.11,0,0,0-.328.789v4.362a1.3,1.3,0,0,0,1.3,1.3h4.512a1.125,1.125,0,0,0,.958-.539l1.479-3.424a1.07,1.07,0,0,0,.1-.443v-.6a1.115,1.115,0,0,0-1.114-1.114h-3.059l.511-2.586a.561.561,0,0,0-.045-.368,2.644,2.644,0,0,0-.488-.678l-.257-.263h0Z" transform="translate(982 6925.001)"/></svg>
</template>

<script>
	export default {
		name: 'tune'
	}
</script>

<style>
	.thumb-up-a {
		fill: #fff;
	}
</style>